import createRequest from 'modules/api/request';
import { URLS, HTTP_METHODS } from 'modules/api/constants';
import { CancelFunctions } from 'components/common/types';

export const pollCreativePendingCount = (
  publisherId: string,
  cancelFunctions: CancelFunctions,
): ((callback: unknown, interval?: number) => Promise<void>) => {
  const reqOptions = {
    url: URLS().FETCH_PENDING_CREATIVE_COUNT(publisherId),
    method: HTTP_METHODS.GET,
  };

  const { poll, cancel } = createRequest(reqOptions);

  if (cancelFunctions.FETCH_PENDING_CREATIVE_COUNT) cancelFunctions.FETCH_PENDING_CREATIVE_COUNT();
  cancelFunctions.FETCH_PENDING_CREATIVE_COUNT = cancel;

  return async (callback: unknown, interval?: number) => {
    try {
      await poll(callback, interval);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug('Creative notifications polling error:', error);
    }
  };
};

export const getPendingCreativeCount = async (
  environmentId: string,
  cancelFunctions: CancelFunctions,
): Promise<number | undefined> => {
  const { send, cancel } = createRequest({
    url: URLS().FETCH_PENDING_CREATIVE_COUNT(environmentId),
    method: HTTP_METHODS.GET,
  });

  if (cancelFunctions.FETCH_PENDING_CREATIVE_COUNT) cancelFunctions.FETCH_PENDING_CREATIVE_COUNT();
  cancelFunctions.FETCH_PENDING_CREATIVE_COUNT = cancel;

  const result = await send();

  return result?.data;
};
